import styled from 'styled-components'
import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import LibraryMembershipImageRecognitionResponse from './LibraryMembershipImageRecognitionResponse'
import toast from 'react-hot-toast'
import { BooksitoutServer } from '../../../../config/BooksitoutServer'
import LibraryMembershipAddImageModal from './LibraryMembershipAddImageModal'
import RowSpacer from '../../../../common/styles/RowSpacer'
import CardBodyContentContainer from '../../../../common/styles/CardBodyContentContainer'
import LibraryMembershipAddManualContent from './LibraryMembershipAddManualContent'
import Modal from '../../../../common/Modal'
import booksitoutIcon from '../../../../config/BooksitoutIcon'

const LibraryAddMembershipRoute = () => {
	const [image, setImage] = useState<string>()
	const [recognizedData, setRecognizedData] = useState<LibraryMembershipImageRecognitionResponse>()
	const [showImageModal, setShowImageModal] = useState<boolean>(false)
	const [showManualModal, setShowManualModal] = useState<boolean>(false)

	const { getRootProps, getInputProps } = useDropzone({
		multiple: false,
		onDrop: useCallback(image => {
			const reader = new FileReader()

			reader.onabort = () => console.log('file reading was aborted')
			reader.onerror = () => console.log('file reading has failed')
			reader.onload = () => {
				toast.loading('이미지를 분석하고 있어요')

				const buffer = reader.result as ArrayBuffer
				const blob = new Blob([buffer])
				const imageUrl = URL.createObjectURL(blob)

				setImage(imageUrl)
				addImage(image[0])
			}

			reader.readAsArrayBuffer(image[0])
		}, []),
	})

	const addImage = imageData => {
		setShowImageModal(true)
		const formData = new FormData()
		formData.append('file', imageData ?? '')

		BooksitoutServer.post('/v1/library/membership/image', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
			.then(res => setRecognizedData(res.data))
			.then(() => toast.success('회원증을 인식했어요! 잘못된 정보가 있다면 수정하고 회원증을 추가해 주세요'))
			.catch(() => toast.error('오류가 났어요! 잠시 후 다시 시도해 주세요'))
	}

	return (
		<>
			<LibraryMembershipAddImageModal image={image} membership={recognizedData} setMembership={setRecognizedData} show={showImageModal} onHide={() => setShowImageModal(false)} />

			<Modal
				isShowing={showManualModal}
				onClose={() => setShowManualModal(false)}
				titleText={'회원증 직접 추가하기'}
				size={'lg'}
				body={<LibraryMembershipAddManualContent onClose={() => setShowManualModal(false)} />}
			/>

			<CardBodyContentContainer>
				<MethodTitle>추가 방법을 선택해 주세요</MethodTitle>
				<RowSpacer />

				<MethodButton onClick={() => setShowManualModal(true)}>
					<MethodIcon><booksitoutIcon.membership /></MethodIcon>
					<MethodTextContainer>
						<MethodName>직접 입력하기</MethodName>
						<MethodDescription>회원증 번호와 종류를 직접 입력해요</MethodDescription>
					</MethodTextContainer>
				</MethodButton>

				<RowSpacer size={10} />

				<MethodButton {...getRootProps()}>
					<input {...getInputProps()} />
					<MethodIcon><booksitoutIcon.image /></MethodIcon>
					<MethodTextContainer>
						<MethodName>사진으로 인식하기</MethodName>
						<MethodDescription>AI가 회원증 사진을 분석해서 정보를 인식해요</MethodDescription>
					</MethodTextContainer>
				</MethodButton>
			</CardBodyContentContainer>
			<RowSpacer />
		</>
	)
}

const MethodTitle = styled.h4`
	font-weight: 700;
	margin: 0;
`

const MethodButton = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 20px;
	border-radius: 16px;
	background-color: var(--card-card-bg-color);
	cursor: pointer;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: var(--search-field-bg-color);
	}

	&:active {
		transform: scale(0.98);
	}
`

const MethodIcon = styled.div`
	font-size: 24px;
	color: var(--text-color);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`

const MethodTextContainer = styled.div`
	display: flex;
	flex-direction: column;
`

const MethodName = styled.span`
	font-size: 16px;
	font-weight: 600;
	color: var(--text-color);
`

const MethodDescription = styled.span`
	font-size: 14px;
	color: var(--sub-text-color);
	margin-top: 2px;
`

export default LibraryAddMembershipRoute
